import React from "react";
import { extractRelevantFieldsByNumber } from "./App";

const PlayerBox = ({ gameInfo, playerColor }) => {

  let playerName = null
  let playerRank = null

  if (gameInfo !== undefined) {
    const {
      playerNames,
      playerRanks,
      blackName, 
      blackRank,
      whiteName,
      whiteRank,
      gameName,
      eventName,
      gameComment,
      date,
      result,
      komi,
      handicap,
      size, 
      gameId,
    } = gameInfo

    playerName = playerColor === 'B' ? blackName : whiteName
    playerRank = playerColor === 'B' ? blackRank : whiteRank

  }

  function roundToNearestHalf(num) {
    return Math.round(num * 2) / 2;
  }

  // Styling for the box
  const boxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    maxWidth: "275px", 
    height: "30px",
    margin: "5px 10px", 
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "bold",
    testAlign: "center",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", // Add some shading
    border: "1px solid rgba(0, 0, 0, 0.1)", // Subtle border for definition
    transition: "background-color 0.5s ease, color 0.5s ease", // shading transition 
    backgroundColor: playerColor === 'B' ? "black" : "white",
    color: playerColor === 'B' ? "white" : "black"
  };

  return (
    <div className="player-box" style={boxStyle}>
      <span>{playerName && (playerRank ? playerName + " " + playerRank : playerName)}</span>
    </div>
  );
};

export default PlayerBox;
